
export const PAGE_ROUTES = {
  HOME: "/",
  HOMECORPORATE: "/Corporate-Venue",
  HOMEBDIAMOND: "/Your-Time-Is-Now",
  HOMELOVEISLOVE: "/Love-Is-Love",
  HOMEBANNERADS: "/Your-Venue",
  HOMEHINMUS: "/Your-Story-At-Shepstone",
  ABOUT: "/About",
  BLOG: "/Blog",
  BLOG_POST: "/Blog-post/:postID",
  FLORALS: "/Florals",
  GALLERY: "/Gallery",
  CONTACT: "/Contact",
  VENUES: "/Venues",
  VENUES_SHEP: "/Venues/Shepstone-Gardens",
  VENUES_HALL: "/Venues/The-Great-Hall",
  VENUES_EXTERNAL: "/Venues/External-Venue",
  VENUES_LATITUDES: "/Venues/Latitudes-Centre-For-The-Arts",
  VENUES_SPA: "/Venues/Shepstone-Spa",
  SHOP: "/Shop",
  THANK_YOU: "/Thank-You",
  MARKET_VENDOR: "/Christmas-Market-Vendor",
  MARKET_TICKETS: "/Event-Tickets",
};

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const ENTRY_POINT = {
  DEFAULT: 0,
  CORPORATE: 1,
  BLACK_DIAMOND: 2,
  LOVE_IS_LOVE: 3,
  BANNER_ADS: 4,
};